@if (content) {
<div>
    <!-- left side part -->
    <div class="c-4 c-12-s c-12-m m-b-0 _sideContent"
         [sizeClass]="'SM:p-l p-r p-t'">
        <!-- no result information -->
        <ng-container *ifSize="'SM'">
            <ng-container *ngTemplateOutlet="noResultInfo"></ng-container>
        </ng-container>
        <!-- init page / popular searches -->
        @if (canShowPopularSerches) {
        <link-list1 class="block"
                    [title]="content.popularSearchesTitle"
                    [items]="popularSearchesAsLinks"></link-list1>
        }
        <!-- init page / feature links -->
        @if (canShowCmsSideContent) {
        <link-list1 class="block"
                    [class.m-t-8]="canShowPopularSerches"
                    [title]="content.featureLinksTitle"
                    [items]="content.featureLinks"></link-list1>
        }
        <!-- search results / XL -->
        <ng-container *ifSize="'XL'">
            <!-- results page / terms -->
            @if (canShowTerms) {
            <link-list1 class="block"
                        [class.m-t-8]="canShowCmsSideContent || canShowPopularSerches"
                        [title]="'Suggested results' | translate"
                        [items]="termsAsLinks"></link-list1>
            }
            <!-- results page / terms -->
            <!-- <link-list1 *ngIf="canShowPages"
        [title]="'Blog posts' | translate"
      [items]="pagesAsLinks"></link-list1> -->
        </ng-container>
        <!-- search results / SM -->
        <ng-container *ifSize="'SM'">
            @if (canShowTerms) {
            <tabs-header>
                @if (canShowTerms) {
                <div [tabsLink]="termsId">{{'Suggested results' | translate}}</div>
                }
                <!-- <div [tabsLink]="postsId"
        *ngIf="canShowPages">{{'Blog posts' | translate}}</div> -->
            </tabs-header>
            }
            @if (canShowTerms) {
            <div [tabsContent]="termsId">
                <link-list1 [items]="termsAsLinks"></link-list1>
            </div>
            }
            <!-- <div [tabsContent]="postsId"
  *ngIf="canShowPages">
  <link-list1 [items]="pagesAsLinks"></link-list1>
</div> -->
        </ng-container>
    </div>
    <!-- content part -->
    <div class="c-8 c-12-s c-12-m m-b-0 m-r-0 m-t-10-s m-t-10-m">
        @switch (canShowProductResults) {
        <!-- init page / content (trending) -->
        @case (false) {
        <!-- no product note in case we should be showing results -->
        <ng-container *ifSize="'XL'">
            <ng-container *ngTemplateOutlet="noResultInfo"></ng-container>
        </ng-container>
        <!-- content title -->
        <h6 class="s1 m-b-5"
            [sizeClass]="'SM:p-l p-r'"
            *iCms="'contentCardsTitle' of content; skipEmpty true"></h6>
        <!-- content cards / XL -->
        <div [grid]="(content.contentCards?.length || 0) > 3 ? 4 : 3"
             *ifSize="'XL'"
             [gridColumnGap]="'40px'">
            @for (item of content.contentCards?.slice(0, 4); track $index) {
            <a [gridColumn]="1"
               [routerLink]="item.link || ''">
                <img class="w-12"
                     [ratio]="1"
                     [dfImage]="item.image"
                     [attr.alt]="item.title">
                <p class="s1 col-1 m-t-3"
                   *iCms="'title' of item; skipEmpty true"></p>
                @if (item.buttonLabel) {
                <button [buttonStyle]
                        class="m-t-4">{{ item.buttonLabel }}</button>
                }
            </a>
            }
        </div>
        <!-- content cards / SM -->
        <carousel class="block m-t-5 p-l-4"
                  [loop]="false"
                  [autoplay]="false"
                  [pagination]="false"
                  [spaceBetween]="10"
                  [slidesPerView]="2.3"
                  [spaceBetween]="16"
                  [navigation]="false"
                  [scrollbar]="false"
                  *ifSize="'SM'"
                  imageViewRoot>
            @for (item of content.contentCards?.slice(0, 4); track $index) {
            <ng-template swiperSlide>
                <a [gridColumn]="1"
                   [routerLink]="item.link || ''">
                    <div class="ratio-1-1">
                        <img [fill]="true"
                             [ratio]="1"
                             [dfImage]="item.image"
                             [attr.alt]="item.title">
                    </div>
                    <p class="s1 col-1 m-t-3"
                       *iCms="'title' of item; skipEmpty true"></p>
                </a>
            </ng-template>
            }
        </carousel>
        @if(result?.term) {
        <search-banner class="m-t-8 m-t-4-s m-t-4-m wrap-s wrap-m"
                       [context]="'preview'"
                       [term]="result.term"></search-banner>
        }

        }
        <!-- results page / content (products) -->
        @case (true) {
        <div [sizeClass]="'SM:p-l p-r'">
            <!-- content title line-->
            <div class="flex flex-justify-between flex-middle m-b-5">
                <h6 class="s1 col-1">{{ 'Products' | translate }}</h6>
                <button [buttonStyle]="'inlineButton'"
                        (click)="gotToSearchView()">{{'View all' | translate}}</button>
                <!-- [status]="status" -->
            </div>
            <!-- products list -->
            <div [grid]="client.sizeId > 1 ? 3 : 1"
                 [gridColumnGap]="client.sizeId > 1 ? '40px' : '16px'"
                 [gridRowGap]="'16px'">
                @for (model of (result?.products?.slice(0, client.sizeId > 1 ? 3 : 4) || []); track model.id) {
                <product [model]="model"
                         [gridColumn]="1"
                         [hideButtons]="true"
                         [searchTerm]="result.term">
                </product>
                }
            </div>
            <search-banner class="m-t-8 m-t-4-s m-t-4-m"
                           [context]="'preview'"
                           [term]="result.term"></search-banner>
        </div>
        }
        }
    </div>
</div>
}

<!-- template for no result info -->
<ng-template #noResultInfo>
    @if (isNoResult) {
    <div class="m-b-5">
        <p class="col-1"
           [sizeClass]="'SM:s2, XL:h3'">
            {{noResultTitle}}
        </p>
        <p class="col-1 m-t-3 m-t-2-s m-t-2-m"
           [sizeClass]="'SM:p2, XL:p1'">
            {{noResultSubtitle}}
        </p>
    </div>
    }
</ng-template>
